(function () {
    'use strict';

    /**
     * All exhibitors section - owns its data, tags and search filters.
     * Used as an attribute on the server rendered <section> (Views/Events/_AllExhibitors.cshtml).
     * No template and a child scope, so the Razor markup inside binds to "allExhibitorsSection"
     * and still sees the page "vm" (getStyle, showLoading, exhibitorClass).
     * When offline the last data saved in the local storage is shown.
     */
    angular
        .module('EventListApp')
        .directive('wsSectionAllExhibitors', sectionAllExhibitors);

    function sectionAllExhibitors() {
        return {
            restrict: 'A',
            scope: true,
            controller: SectionAllExhibitorsCtrl,
            controllerAs: 'allExhibitorsSection'
        };
    }

    SectionAllExhibitorsCtrl.$inject = ['$element', 'ApiFactory', 'SectionRegistry', '$localstorage'];

    function SectionAllExhibitorsCtrl($element, ApiFactory, SectionRegistry, $localstorage) {
        const vm = this;
        vm.items = [];
        // tags + searchTags stay undefined until the tags are loaded (same as the old EventCtrl code, filterMultiple depends on it)

        vm.$onInit = function () {
            SectionRegistry.register($element[0].id, load);
        };

        /**
         * Load the exhibitors and their tags
         * @param {number} eventId
         * @param {number} lang
         * @returns {Promise<boolean>|boolean} true when data was received
         */
        function load(eventId, lang) {
            const storageKey = 'allexhibitors_' + eventId;
            loadTags(eventId, lang);

            if (!navigator.onLine) {
                vm.items = $localstorage.GetNoExpiry(storageKey) || [];
                return true;
            }

            return ApiFactory.GetAllExhibitors(eventId, lang).then(function (response) {
                if (response.data == null)
                    return false;

                $localstorage.Save(storageKey, response.data);
                vm.items = response.data;
                return true;
            });
        }

        function loadTags(eventId, lang) {
            ApiFactory.GetExhibitorTags(eventId, lang).then(function (tags) {
                vm.tags = tags;
                vm.searchTags = [];
                for (let i = 0; i < vm.tags.length; i++) {
                    vm.searchTags[i] = "0";
                }
            });
        }
    }
})();
